import React from 'react';
import { Header } from '../components/Header';
import { BlogHeroVariantA } from '../components/blog/BlogHeroVariantA';
import { BlogFeatured } from '../components/blog/BlogFeatured';
import { BlogFilters } from '../components/blog/BlogFilters';
import { BlogGrid } from '../components/blog/BlogGrid';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function BlogPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-373">
      <Header data-id="element-374" />
      <main data-id="element-375">
        <BlogHeroVariantA data-id="element-376" />
        <BlogFeatured data-id="element-377" />
        <BlogFilters data-id="element-378" />
        <BlogGrid data-id="element-379" />
        <CTASection data-id="element-380" />
      </main>
      <Footer data-id="element-381" />
    </div>;
}